import { CheckOutlined, CloseOutlined, LineOutlined } from "@ant-design/icons";
import { Input } from "antd";
import React, { useMemo, useState } from "react";

function formatCelular(value) {
  const digits = (value || "").replace(/\D/g, "");
  if (digits.length <= 10) {
    return digits
      .replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3")
      .replace(/[-\s]$/, "");
  }
  return digits
    .replace(/^(\d{2})(\d{5})(\d{0,4})$/, "($1) $2-$3")
    .replace(/[-\s]$/, "");
}

function parseCelular(value) {
  return (value || "").replace(/\D/g, "");
}

function isValidCelular(value) {
  const digits = parseCelular(value);
  return /^(\d{10}|\d{11})$/.test(digits);
}

export default function InputCelular({
  value = "",
  onChange,
  onBlur,
  onFocus,
  suffix,
  ...props
}) {
  const [editing, setEditing] = useState(false);
  const formattedValue = useMemo(() => formatCelular(value), [value]);
  const isValid = useMemo(() => isValidCelular(value), [value]);

  const fireChange = (newValue) => {
    if (newValue === value) return;
    if (typeof onChange === "function") onChange(newValue);
  };

  const handleBlur = (e) => {
    setEditing(false);
    if (typeof onBlur === "function") onBlur(e);
  };

  const handleChange = (e) => fireChange(parseCelular(e.target.value));

  const handleFocus = (e) => {
    setEditing(true);
    const target = e.target;
    setImmediate(() => target.setSelectionRange(0, target.value.length));
    if (typeof onFocus === "function") onFocus(e);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    fireChange(parseCelular(e.clipboardData.getData("text")));
  };

  const suffix2 = !value ? (
    <LineOutlined />
  ) : isValid ? (
    <CheckOutlined className="success" />
  ) : (
    <CloseOutlined className="error" />
  );

  return (
    <Input
      maxLength={editing ? 11 : undefined}
      onBlur={handleBlur}
      onChange={handleChange}
      onFocus={handleFocus}
      onPaste={handlePaste}
      suffix={suffix ?? suffix2}
      value={editing ? value : formattedValue}
      {...props}
    />
  );
}
